import { config } from '../../config';
import { getFranchisee } from '../Franchisee';

const DomainUtils = async () => {
  //   const siteURL = config?.siteURL;
  //   const urlPath = window?.location?.host?.split(siteURL);
  let franchisee = null;

  //   if (urlPath[0] !== '') {
  //     franchisee = localStorage.getItem('franchisee');
  //     if (franchisee) {
  //       return [franchisee];
  //     } else {
  //       let subDomain = window.location?.host;
  //       if (urlPath.length > 1) {
  //         subDomain = urlPath[0]?.split('.');
  //         subDomain = subDomain[0];
  //       }
  //       const response = await getFranchisee(subDomain);
  //       if (response.status === 'success') {
  //         if (response.isValid) {
  //           franchisee = response.franchisee;
  //           localStorage.setItem('franchisee', franchisee);
  //         } else {
  //           console.log('Invalid domain provided');
  //         }
  //       } else {
  //         console.log('Api call failed');
  //       }
  //       return [franchisee];
  //     }
  //   }

  franchisee = localStorage.getItem('franchiseeId');
  if (franchisee) {
    return [franchisee];
  } else {
    const host = checkWWW(window?.location?.host);
    let sd = null;
    const domains = host?.split('.');
    const initialDomain = domains.find(
      (element) => element == config.siteURL.split('.')[0]
    );
    if (initialDomain) {
      const subdomain = host?.split('.')[0];
      sd = subdomain;
    } else {
      sd = host;
    }

    const response = await getFranchisee(sd);
    if (response.status === 'success') {
      if (response.isValid) {
        franchisee = response.franchisee;
        localStorage.setItem('franchiseeId', franchisee);
        if (response?.domain && response?.domain != '') {
          localStorage.setItem('isCustomDomain', 'true');
        } else {
          localStorage.setItem('isCustomDomain', 'false');
        }
      } else {
        console.log('Invalid domain provided');
      }
    } else {
      console.log('Api call failed');
    }
    return [franchisee];
  }
};

export default DomainUtils;

const checkWWW = (host) => {
  const domains = host?.split('.');
  //const domains = ['www', 'bbn', 'localhost:3001', 'com'];
  const www = domains.shift();
  if (www === 'www') {
    //console.log('We found www in url. Removing WWW..');
    let customDomain = '';
    domains.map((element, index) => {
      const dot = index == 0 ? '' : '.';
      customDomain = customDomain + dot + `${element}`;
    });
    return customDomain;
  } else {
    return host;
  }
};
